import React, {useEffect, useState} from "react";

import Page from "components/Page";
import {SelectUsers} from "components/Select";
import PaginationTable from "components/Pagination";

import {Card, Col, Row, ToggleButton} from "react-bootstrap";
import {i18n} from 'translate/i18n'
import {getAllComments, getComments} from "services/Comments.service";
import {format} from "date-fns";
import {useUser} from "store/providers/app";
import {useQuery} from "react-query";

import Loading from "../../components/Loading";
import {compare} from "utils/actions"
import {Tooltip} from "../../components/Tooltip";

const Notifications = () => {

    const {user} = useUser();

    const [comments, setComments] = useState([]);
    const [paginate, setPaginate] = useState([])
    const [username, setUser] = useState('');
    const [selected, setSelected] = useState(user.username);

    const [currentPage, setCurrentPage] = useState(1);
    const [checked, setChecked] = useState(false)

    const {isLoading} = useQuery(["allComments", selected, username, currentPage],
        () => {
            return getAllComments(selected, username, currentPage)
        }, {
            onSuccess: (res) => {
                setComments(res.data.data)
                setPaginate({
                    total: res.data.total,
                    from: res.data.from,
                    to: res.data.to
                })
            },
            onError: (error) => {
                console.log(error.response)
            },
            retry: false,
            refetchOnWindowFocus: false,
            keepPreviousData: true,
        }
    )

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1)
    };

    function handleOnChange(data) {
        setSelected(data);
    }

    const handleMentions = (e) => {
        setChecked(e.currentTarget.checked)
        if (e.currentTarget.checked) {
            setUser(user.id);
        } else {
            setUser('');
        }
    }

    return (
        <Page label={i18n.t('titlePage.notifications')} icon="bi bi-chat-right ">

            { user.profile === 1 &&
                <div className="card mt-3 border-0 shadow-sm">
                    <div className="card-body">
                        <SelectUsers
                            onChangeUsers={(e) => handleOnChange(e.label)}
                            defaultUser={username}
                        />
                    </div>
                </div>
            }

            { isLoading ? <Loading/> :
                <div className="card mt-3 border-0 shadow-sm">
                    <div className="card-header py-3">
                        <ToggleButton
                            className="float-end"
                            id="toggle-mentions"
                            type="checkbox"
                            variant="outline-primary"
                            checked={checked}
                            value="1"
                            onChange={(e) => handleMentions(e)}
                        >
                            <i className="bi bi-at"/>
                        </ToggleButton>
                    </div>

                    <div className="card-body p-0">

                        <table className="table mb-0">
                            <thead className="bg-primary text-uppercase text-sm">
                                <tr>
                                    <th colSpan={2} className="py-4">
                                        {i18n.t('label.messagesUsers')}
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                            {!comments?.length &&
                                <tr>
                                    <td>{i18n.t('upload.tableRecords')}</td>
                                </tr>
                            }

                            {comments?.map((item, index) =>
                                <React.Fragment key={item.id}>
                                    <tr>
                                        <td className="text-sm">
                                            <span className="text-primary">@{item.username} </span>
                                            {item.commentable_type === 'App\\Models\\Goal' ? i18n.t('messages.complementGoal') : i18n.t('messages.complement')}
                                            <b>{item.commentable?.titulo || item.commentable?.titulo_meta}</b>
                                        </td>
                                        <td width={10}>
                                            <Tooltip label={i18n.t('buttons.more')}>
                                                <button className="btn btn-outline-primary btn-sm mt-2" type="button"
                                                        data-bs-toggle="collapse" data-bs-target={`#collapse-${index}`}
                                                        aria-expanded="true" aria-controls={`collapse-${index}`}>
                                                    <i className="bi bi-eye"/>
                                                </button>
                                            </Tooltip>
                                        </td>
                                    </tr>
                                    <tr className="border-top-0">
                                        <td colSpan={5} className="pt-0 pb-0 bg-light">
                                            <div id={`collapse-${index}`} className="accordion-collapse collapse"
                                                 aria-labelledby="comments" data-bs-parent={`#collapse-${index}`}>
                                                <div className="accordion-body">
                                                    <span className=" text-muted text-sm">
                                                         {format(new Date(item.created_at), 'dd/MM/yyyy - HH:mm')}
                                                    </span>
                                                    <p>
                                                        {item.comment}
                                                    </p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </React.Fragment>
                            )}
                            </tbody>
                        </table>
                    </div>
                    <PaginationTable
                        paginate={paginate}
                        handlePageClick={handlePageClick}
                    />
                </div>
            }
        </Page>
    );
}

export default Notifications
